import utils from '../utils/utils'
import anime from '../libs/anime'
import Hammer from '../libs/hammer'
import globalVar from '../utils/globalVar'

class Divertissement {
  constructor() {
    const tablet = window.matchMedia("(max-width: 1040px)");
    let cache = {};
    let timerHero1;
    let indexHero1 = 0;
    let timerHero2;
    let indexHero2 = 0;
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      if(document.querySelector('#vr .sub_hero')) {
        cache.subhero1 = document.querySelector('#vr .sub_hero');
        cache.subhero1Slider = cache.subhero1.querySelector('.slider');
        cache.subhero1Slides = cache.subhero1.querySelectorAll('.slider .slide');
        cache.subhero1SliderNav = cache.subhero1.querySelectorAll('.slider_nav .dot');
        cache.dropHoraire1Arrow = document.querySelector('#vr .tablet_info .top');
        cache.dropHoraire1 = document.querySelector('#vr .tablet_info .drop .horaire');
      }

      if(document.querySelector('#cinema .sub_hero')) {
        cache.subhero2 = document.querySelector('#cinema .sub_hero');
        cache.subhero2Slider = cache.subhero2.querySelector('.slider');
        cache.subhero2Slides = cache.subhero2.querySelectorAll('.slider .slide');
        cache.subhero2SliderNav = cache.subhero2.querySelectorAll('.slider_nav .dot');
        cache.dropHoraire2Arrow = document.querySelector('#cinema .tablet_info .top');
        cache.dropHoraire2 = document.querySelector('#cinema .tablet_info .drop .horaire');
      }

    };

    let registerEvents = () => {
      if(cache.subhero1.querySelector('.slider_nav')) {
        for (let i = 0; i < cache.subhero1SliderNav.length; i++) {
          cache.subhero1SliderNav[i].addEventListener("click", function() {
            heroSlide(this.dataset.index, cache.subhero1);
          });
        }
        timerHero1 = setInterval(timerHero1Slide, 3000);
        let hammertime = new Hammer(cache.subhero1);
        hammertime.on('swipe', function(ev) {
          if(ev.direction == 2) {
            if(indexHero1 == cache.subhero1Slides.length-1) {
              indexHero1 = 0;
            } else {
              indexHero1++;
            }
            heroSlide(indexHero1, cache.subhero1);
          }
          if(ev.direction == 4) {
            if(indexHero1 == 0) {
              indexHero1 = cache.subhero1Slides.length-1;
            } else {
              indexHero1--;
            }
            heroSlideRight(indexHero1, cache.subhero1);
          }
        });

        cache.dropHoraire1Arrow.addEventListener("click", dropHoraire1);
      }

      if(cache.subhero2.querySelector('.slider_nav')) {
        for (let i = 0; i < cache.subhero2SliderNav.length; i++) {
          cache.subhero2SliderNav[i].addEventListener("click", function() {
            heroSlide(this.dataset.index, cache.subhero2);
          });
        }
        timerHero2 = setInterval(timerHero2Slide, 3000);
        let hammertime = new Hammer(cache.subhero2);
        hammertime.on('swipe', function(ev) {
          if(ev.direction == 2) {
            if(indexHero2 == cache.subhero2Slides.length-1) {
              indexHero2 = 0;
            } else {
              indexHero2++;
            }
            heroSlide(indexHero2, cache.subhero2);
          }
          if(ev.direction == 4) {
            if(indexHero2 == 0) {
              indexHero2 = cache.subhero2Slides.length-1;
            } else {
              indexHero2--;
            }
            heroSlideRight(indexHero2, cache.subhero2);
          }
        });

        cache.dropHoraire2Arrow.addEventListener("click", dropHoraire2);
      }
    };


    let heroSlide = function(index, sliderContainer) {
      if(sliderContainer.parentNode.id == "vr") {
        clearInterval(timerHero1);
        indexHero1 = index;
      }
      else {
        clearInterval(timerHero2);
        indexHero2 = index;
      }

      let current = sliderContainer.querySelector('.slide.active');
      let currentDot = sliderContainer.querySelector('.slider_nav .dot.active');
      let slider = sliderContainer.querySelector('.slider');
      let slides = slider.querySelectorAll('.slide');
      let sliderNav = sliderContainer.querySelectorAll('.slider_nav .dot');
      let target = slides[index];
      let targetDot = sliderNav[index];

      current.classList.remove('active');
      currentDot.classList.remove('active');
      target.classList.add('active');
      targetDot.classList.add('active');

      anime({
        targets: current,
        scale: [0.9],
        duration: 350,
        easing: 'easeOutCubic',
        delay: 75,
        complete: function() {
          anime({
            targets: current,
            translateX: ['0%', '-150%'],
            duration: 600,
            easing: 'easeOutCubic',
            complete: function() {
              current.style.opacity = 0;
            }
          });
        }
      });

      anime({
        targets: target,
        scale: [0.9],
        duration: 350,
        easing: 'easeOutCubic',
        complete: function() {
          target.style.opacity = 1;
          anime({
            targets: target,
            translateX: ['150%', '0%'],
            duration: 600,
            easing: 'easeOutCubic',
            complete: function() {
              if(sliderContainer.parentNode.id == "vr") {
                timerHero1 = setInterval(timerHero1Slide, 3000);
              }
              else {
                timerHero2 = setInterval(timerHero2Slide, 3000);
              }
              anime({
                targets: target,
                scale: [1],
                duration: 400,
                easing: 'easeOutCubic',
              });
            }
          });
        }
      });
    }

    let heroSlideRight = function(index, sliderContainer) {
      if(sliderContainer.parentNode.id == "vr") {
        clearInterval(timerHero1);
        indexHero1 = index;
      }
      else {
        clearInterval(timerHero2);
        indexHero2 = index;
      }

      let current = sliderContainer.querySelector('.slide.active');
      let currentDot = sliderContainer.querySelector('.slider_nav .dot.active');
      let slider = sliderContainer.querySelector('.slider');
      let slides = slider.querySelectorAll('.slide');
      let sliderNav = sliderContainer.querySelectorAll('.slider_nav .dot');
      let target = slides[index];
      let targetDot = sliderNav[index];

      current.classList.remove('active');
      currentDot.classList.remove('active');
      target.classList.add('active');
      targetDot.classList.add('active');

      anime({
        targets: current,
        scale: [0.9],
        duration: 350,
        easing: 'easeOutCubic',
        delay: 75,
        complete: function() {
          anime({
            targets: current,
            translateX: ['0%', '150%'],
            duration: 600,
            easing: 'easeOutCubic',
            complete: function() {
              current.style.opacity = 0;
            }
          });
        }
      });

      anime({
        targets: target,
        scale: [0.9],
        duration: 350,
        easing: 'easeOutCubic',
        complete: function() {
          target.style.opacity = 1;
          anime({
            targets: target,
            translateX: ['-150%', '0%'],
            duration: 600,
            easing: 'easeOutCubic',
            complete: function() {
              if(sliderContainer.parentNode.id == "vr") {
                timerHero1 = setInterval(timerHero1Slide, 3000);
              }
              else {
                timerHero2 = setInterval(timerHero2Slide, 3000);
              }
              anime({
                targets: target,
                scale: [1],
                duration: 400,
                easing: 'easeOutCubic',
              });
            }
          });
        }
      });
    }


    let timerHero1Slide = function() {
      if(indexHero1 == cache.subhero1Slides.length-1) {
        indexHero1 = 0;
      } else {
        indexHero1++;
      }
      heroSlide(indexHero1, cache.subhero1);
    }
    let timerHero2Slide = function() {
      if(indexHero2 == cache.subhero2Slides.length-1) {
        indexHero2 = 0;
      } else {
        indexHero2++;
      }
      heroSlide(indexHero2, cache.subhero2);
    }

    let dropHoraire1 = function() {
      if(cache.dropHoraire1.classList.contains('open')) {
        cache.dropHoraire1.classList.remove('open');
        anime({
          targets: cache.dropHoraire1,
          height: 0,
          duration: 400,
          easing: 'easeOutCubic',
          complete: function() {
            cache.dropHoraire1.style.display = 'none';
          }
        });
        anime({
          targets: cache.dropHoraire1Arrow.querySelector('.arrow'),
          rotate: 0,
          duration: 400,
          easing: 'easeOutCubic'
        });
      } else {
        cache.dropHoraire1.classList.add('open');
        cache.dropHoraire1.style.display = 'block';
        cache.dropHoraire1.style.height = 'auto';
        let height = cache.dropHoraire1.offsetHeight;
        cache.dropHoraire1.style.height = 0;

        anime({
          targets: cache.dropHoraire1,
          height: height,
          duration: 400,
          easing: 'easeOutCubic'
        });
        anime({
          targets: cache.dropHoraire1Arrow.querySelector('.arrow'),
          rotate: 180,
          duration: 400,
          easing: 'easeOutCubic'
        });

      }
    }

    let dropHoraire2 = function() {
      if(cache.dropHoraire2.classList.contains('open')) {
        cache.dropHoraire2.classList.remove('open');
        anime({
          targets: cache.dropHoraire2,
          height: 0,
          duration: 400,
          easing: 'easeOutCubic',
          complete: function() {
            cache.dropHoraire2.style.display = 'none';
          }
        });
        anime({
          targets: cache.dropHoraire2Arrow.querySelector('.arrow'),
          rotate: 0,
          duration: 400,
          easing: 'easeOutCubic'
        });
      } else {
        cache.dropHoraire2.classList.add('open');
        cache.dropHoraire2.style.display = 'block';
        cache.dropHoraire2.style.height = 'auto';
        let height = cache.dropHoraire2.offsetHeight;
        cache.dropHoraire2.style.height = 0;

        anime({
          targets: cache.dropHoraire2,
          height: height,
          duration: 400,
          easing: 'easeOutCubic'
        });
        anime({
          targets: cache.dropHoraire2Arrow.querySelector('.arrow'),
          rotate: 180,
          duration: 400,
          easing: 'easeOutCubic'
        });

      }
    }

    initFunc();
  };
}
export { Divertissement }
